import { gql } from '@apollo/client';

export const GET_SIGNED_URL = gql`
  query getUploadURL($key: String!) {
    getUploadURL(key: $key)
  }
`;
